// extracted by mini-css-extract-plugin
export default {"he":"h_he__5s9A5"};